export const desktop = '@media only screen and (min-width: 768.1px)'

export const mobile = '@media only screen and (max-width: 768px)'

export const mobile_max_width = '(max-width: 768px)'